/**
 * SONE — branded identifier types and schema versioning.
 *
 * Branded strings cost nothing at runtime but stop the single most common
 * class of bug in a system with this many id kinds: passing a PageId where
 * a BlockId belongs. Construct them via the `as*` helpers so every
 * conversion from a raw string is visible in a diff.
 */
export const asWorkspaceId = (s) => s;
export const asUserId = (s) => s;
export const asPageId = (s) => s;
export const asBlockId = (s) => s;
export const asCollectionId = (s) => s;
export const asFieldId = (s) => s;
export const asViewId = (s) => s;
export const asFileId = (s) => s;
export const asShareTokenId = (s) => s;
export const asFractionalIndex = (s) => s;
export const asTimestamp = (d = new Date()) => d.toISOString();
/**
 * Document schema version.
 *
 * Every persisted Y.Doc carries this under the `meta` map. Migrations run
 * lazily on document open and are append-only: a document written by a newer
 * SONE than the one reading it must be refused, not guessed at.
 *
 * Bump SCHEMA_VERSION whenever the *shape* of persisted data changes. Adding
 * an optional field does not require a bump. Renaming, removing or changing
 * the meaning of a field does.
 */
// Version 6 also fences off editors that can restore remotely deleted blocks.
// Version 7 adds attributes an older editor would strip (see migrations.ts).
export const SCHEMA_VERSION = 7;
//# sourceMappingURL=ids.js.map